'use client';

import { CloseIcon } from '@chakra-ui/icons';
import { IconButton, Spinner } from '@chakra-ui/react';
import { useQueryState } from 'nuqs';
import React, { useEffect, useRef, useState, useTransition } from 'react';

import { useDebounce } from '@/utils/hooks';

import { useClearFilters } from '../../_components/filters/new-filters/utils';

import styles from './UsedCarSearchQuery.module.scss';

const UsedCarSearchQuery = () => {
  const [search, setSearch] = useState('');
  const [isPending, startTransition] = useTransition();

  const inputRef = useRef<HTMLInputElement>(null);

  const [query, setQuery] = useQueryState('search', {
    shallow: false,
    clearOnDefault: true,
    defaultValue: '',
    startTransition,
  });

  useEffect(() => {
    setSearch(query);
  }, [query]);

  const clearFilters = useClearFilters();

  const debouncedChange = useDebounce((value) => {
    setQuery(value);
    if (value) {
      clearFilters();
    }
  });

  useEffect(() => {
    debouncedChange(search);
  }, [search, debouncedChange]);

  return (
    <div className={styles.Container}>
      <input
        placeholder="Search (eg. 'white automatic KIA Picanto')"
        className={styles.SearchInput}
        value={search}
        ref={inputRef}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
      />
      {search && !isPending ? (
        <IconButton
          aria-label="Clear search"
          position="absolute"
          background="transparent"
          right={0}
          opacity={0.6}
          onClick={() => {
            setSearch('');
            inputRef.current?.focus();
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
      {isPending ? (
        <Spinner
          position="absolute"
          right={4}
          pointerEvents="none"
          opacity={0.6}
        />
      ) : null}
    </div>
  );
};

export default UsedCarSearchQuery;
